import React from "react";
import useUser from "../../../../hooks/useUser";
import { useFetch } from "../../../../hooks/Fetching";
import { CLINIC_CATEGORIES } from "../../../../enums/ApiPaths";
import { DOC_CATEGORY } from "../../../../enums/QueryKeys";
import { useTranslation } from "react-i18next";

export default function useGetCategoreis(url, userId, queryId) {
  const { currentClinic } = useUser();
  const id = userId ? userId : currentClinic?.id;
  const apiPath = url ? url : CLINIC_CATEGORIES;
  const { data, isLoading, error } = useFetch(
    apiPath,
    id,
    DOC_CATEGORY + queryId,
    id != null,
  );

  const [translatedCategories, setTranslatedCategories] = React.useState([]);
  const { i18n } = useTranslation();

  React.useEffect(() => {
    if (data && !isLoading && !error) {
      const defaultCat = data?.defaultDocCategory;
      const cat = [...data?.clinicCategories, defaultCat];
      const currentLang = i18n?.language;

      if (data?.clinicCategories?.length == 0 && defaultCat == null) {
        const translation = [];
        setTranslatedCategories(translation);
      } else {
        const translation = cat?.map((category) => {
          if (category?.translations) {
            return {
              id: category.id,
              title: category?.translations[currentLang] || category.title,
            };
          } else {
            return {
              id: category.id,
              title: category.title,
            };
          }
        });
        setTranslatedCategories(translation);
      }
    }
  }, [data, isLoading, i18n.language]);

  return { isLoading, error, translatedCategories };
}
//We are fetching categories over appointment ID because a master can also perfom this action and he does not belong to a clinic
export function useGetCategoreisOverAppointment(appointmentId) {
  const endpoint = "/clinics/categories/appointment/" + appointmentId;
  const { data, isLoading, error } = useFetch(
    endpoint,
    null,
    DOC_CATEGORY + appointmentId,
  );

  const [translatedCategories, setTranslatedCategories] = React.useState([]);
  const { i18n } = useTranslation();

  React.useEffect(() => {
    if (data && !isLoading && !error) {
      const defaultCat = data?.defaultDocCategory;
      const cat = [...data?.clinicCategories, defaultCat];
      const currentLang = i18n?.language;
      if (data?.clinicCategories?.length == 0 && defaultCat == null) {
        const translation = [];
        setTranslatedCategories(translation);
      } else {
        const translation = cat?.map((category) => {
          if (category?.translations) {
            return {
              id: category.id,
              title: category?.translations[currentLang] || category.title,
            };
          } else {
            return {
              id: category.id,
              title: category.title,
            };
          }
        });
        setTranslatedCategories(translation);
      }
    }
  }, [data, isLoading, i18n.language]);

  return { isLoading, error, translatedCategories };
}
